import { MasteryStatus } from '../enums/mastery-status.enum';

export const StandardHeaderColorConfig: { [key: string]: string } = {
  [MasteryStatus.NotFullyMastered]: '#E8F9EA',
  [MasteryStatus.NotMastered]: '#F2F2F2',
  [MasteryStatus.NotEvaluated]: '#F2F2F2',
  [MasteryStatus.Mastered]: '#E0F1DF',
};
